import type { paths } from '@luxuryescapes/contract-svc-accommodation'

import request from 'api/requestUtils'
import { mapAccommodationEnquirySession } from 'api/mappers/accommodationEnquirySessionMap'

type ServerCreateEnquirySession = paths['/api/accommodation/bookings/enquiry-sessions']['post']
// NB: `brand` is supplied by `brandLoader` middleware.
type ServerCreateEnquirySessionRequestBody = Omit<
  ServerCreateEnquirySession['requestBody']['content']['application/json'],
  'brand'
>
type ServerCreateEnquirySessionResponse =
  ServerCreateEnquirySession['responses']['201']['content']['application/json']

type EnquirySessionBundlePayload = NonNullable<ServerCreateEnquirySessionRequestBody['bundle']>

/**
 * Create-session body. `optInBundle` is additive to the published 22.0.1 contract so a mandatory
 * `bundle` and a selected optional bundle can both be persisted on the same session.
 */
export type CreateEnquirySessionPayload = ServerCreateEnquirySessionRequestBody & {
  optInBundle?: EnquirySessionBundlePayload
  createdContext?: {
    userContext?: {
      isLuxPlusUser?: boolean
    }
  }
}

export async function createEnquirySession(
  payload: CreateEnquirySessionPayload,
): Promise<App.AccommodationEnquirySession> {
  const response = await request.post<ServerCreateEnquirySessionResponse, CreateEnquirySessionPayload>(
    '/api/accommodation/bookings/enquiry-sessions',
    payload,
    { credentials: 'include' },
  )
  return mapAccommodationEnquirySession(response.result)
}
